/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { useEffect } from 'react';
import { css } from '@emotion/react';

import { useDetermineMobile } from '@myrealtrip/device-detect';

import styled from '@emotion/styled';

import GNB from '../components/GNB';
import LNB from '../components/LNB';
import { getHeaderThemeByPathName } from '../utils/getHeaderThemeByPathName';
import {
  HeaderThemeType,
  HeaderSizeType,
  HeaderThemeMessage,
  HeaderTheme,
  HeaderSize,
  HeaderZindex,
} from '../../constants/header';
import { useLayoutHeaderContext } from '../../modules/LayoutHeaderContext';
import { globalVariables } from '../../shared/designSystem/constants';

interface Props {
  hideGnb?: boolean;
  hideLnb?: boolean;
}

export default function Header({ hideGnb = false, hideLnb = false }: Props) {
  const { theme, size, isDisabled, setSize, setTheme, setDisabled, setExcludeLnb } =
    useLayoutHeaderContext();
  const isMobile = useDetermineMobile();

  // 최초 마운트 시 Header 컴포넌트 테마 설정
  useEffect(() => {
    const initialTheme = getHeaderThemeByPathName({
      isMobile,
      currentPathName: window.location.pathname,
    });

    setTheme(initialTheme);
  }, [isMobile, setTheme]);

  // postMessage를 통해 Header theme, size를 변경할 수 있다.
  useEffect(() => {
    const handleThemeChange = (event: MessageEvent<HeaderThemeMessage>) => {
      const {
        data: { type, value },
      } = event;

      if (type !== 'MRT_HEADER_CHANGES') {
        return;
      }
      setTheme(value?.theme ?? 'white');
      setSize(value?.size ?? 'default');
      setDisabled(value?.disabled ?? false);
      setExcludeLnb(value?.excludeLnb ?? false);
    };

    window.addEventListener('message', handleThemeChange);

    return () => window.removeEventListener('message', handleThemeChange);
  }, [setSize, setTheme]);

  if (isDisabled) {
    return null;
  }

  return (
    <Container id="mrt-main-header" colorTheme={theme} size={size}>
      {!hideGnb && <GNB />}
      {!hideLnb && <LNB />}
    </Container>
  );
}

const HEADER_THEME_STYLE = {
  [HeaderTheme.blue]: css`
    background-color: ${globalVariables.blue_500};
    color: ${globalVariables.white};
  `,
  [HeaderTheme.white]: css`
    background-color: ${globalVariables.white};
    color: ${globalVariables.gray_600};
  `,
  [HeaderTheme.transparent]: css`
    background-color: transparent;
    color: ${globalVariables.white};
    z-index: 101 !important;
  `,
};

const Container = styled.header<{
  colorTheme: HeaderThemeType;
  size: HeaderSizeType;
}>`
  position: relative;
  width: 100%;
  height: auto;
  z-index: ${HeaderZindex.default};

  ${({ colorTheme }) => HEADER_THEME_STYLE[colorTheme]}
  ${({ size }) =>
    size === HeaderSize.full &&
    css`
      position: fixed;
      width: 100%;
      z-index: 9999 !important;

      nav {
        max-width: none;
        padding: 0 32px;
      }
    `};
`;
